import { SubmissionFileType, State } from '@/types'
import { Store } from 'vuex'
import { ComputedRef } from 'vue'
import { createVerifyResult, applyValidationResults, validateField } from './utils'
import limits from '../../constants/limits'

export default async function validateArticleInfoView(
  store: Store<State>,
  title: ComputedRef<string>,
  abstract: ComputedRef<string>,
  ccdcNumbers: ComputedRef<string>,
) {
  const crystalDataAdded = store.state.activeSubmission.files.some(
    file => file.type === SubmissionFileType.CrystalData,
  )
  const verifyResult = createVerifyResult('ArticleInfo')

  const validationResults = (await Promise.all([
    validateField(title.value, 'article-title-required'),
    validateField(abstract.value, 'article-abstract-required'),
    validateField(title.value, `max-words:${limits.manuscript.words.title},title`),
    validateField(abstract.value, `max-words:${limits.manuscript.words.abstract},abstract`),
    crystalDataAdded ? validateField(ccdcNumbers.value, 'ccdc-deposition-number-required') : null,
    crystalDataAdded
      ? validateField(ccdcNumbers.value, `max-characters-length:${limits.CCDC.characters.data},Your CCDC numbers must not exceed`)
      : null,

  ])).filter(Boolean)

  applyValidationResults(validationResults, verifyResult)

  verifyResult.valid = verifyResult.errors.length === 0
  store.commit('setVerifyResult', {
    key: 'articleInfoVerifyResult',
    verifyResult,
  })

  if (verifyResult.valid) {
    store.dispatch('setTitleAndAbstract', {
      title: title.value,
      abstract: abstract.value,
    })
    store.dispatch('setCcdcNumbers', ccdcNumbers.value)
  }
}
